import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getPharmacyList
 * @param id
 * @description This function  will fetch the clinic group list.
 */
export const getPharmacyList = (pageNo, searchText, stateName) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/pharmacies?page=${pageNo}&perpage=10`;

  if (searchText) {
    url = url + "&search_text=" + searchText;
  }

  if (stateName) {
    url = url + "&filter_type=state&filter_text=" + stateName;
  }
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getPharmacyDetails
 * @param  pharmacyId
 * @desc  get pharmacy details
 */

export const getPharmacyDetails = pharmacyId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/pharmacies/${pharmacyId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};
